// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: true,
  firebase: {
    apiKey: "AIzaSyCFWVeRsts2SwyzCRtTuXPvjlhGuCsluOQ",
    authDomain: "pngl-007.firebaseapp.com",
    databaseURL: "https://pngl-007.firebaseio.com",
    projectId: "pngl-007",
    storageBucket: "pngl-007.appspot.com",
    messagingSenderId: "1025997853811",
    appId: "1:1025997853811:web:0424bcbed20f7477f8c606",
    measurementId: "G-3J2B6RWC8Q"
  }
};


/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
